import { useAppDispatch } from '@/app/reduxHooks';
import { getWebSocketUrl } from '@/config/websocket.config';
import { wsManager } from '@/lib/websocket';
import { useEffect } from 'react';
import Canvas from '../../components/canvas/Canvas';
import Header from '../../components/header/Header';
import { PipelinesList } from '../../components/pipeline-list/PipelinesList';
import Sidebar from '../../components/sidebar/Sidebar';
import { useAdpSessionStore } from '../../hooks/useAdpSessionStore';
import { useSidebarTab } from '../../hooks/useSidebarTab';
import { clearCanvas } from '../../state/canvas/canvasSlice';
import { resetPipelineState } from '../../state/pipelineSlice';
import styles from './DataPipelinePage.module.scss';

const DataPipelinePage = () => {
  const { tab } = useSidebarTab();
  const { clearAll } = useAdpSessionStore();
  const dispatch = useAppDispatch();

  useEffect(() => {
    clearAll();
    dispatch(clearCanvas());
    dispatch(resetPipelineState());

  }, [clearAll, dispatch]);

  useEffect(() => {
    wsManager.connect(getWebSocketUrl());

    return () => {
      wsManager.disconnect();
    };
  }, []);

  return (
    <section className={styles.dataPipelinePage}>
      <Header />
      <div className={styles.workspace}>
        <Sidebar />
        {tab === 'pipelines' ? (
          <PipelinesList />
        ) : (
          <Canvas />
        )}
      </div>
    </section>
  )
}

export default DataPipelinePage;
